import cn from 'clsx';
import React, { TextareaHTMLAttributes } from 'react';
import s from 'src/shared/styles/ui/Input/Input.module.css';

export interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string;
  onChange?: (...args: any[]) => any;
}

const TextArea: React.FC<
  TextAreaProps & {
    noStyle?: boolean;
    withTarget?: boolean;
    shadow?: boolean;
  }
> = (props) => {
  const { className, children, onChange, shadow, withTarget, noStyle, ...rest } = props;

  const rootClassName = cn(
    noStyle ? { [s.noStyle]: noStyle, [s.shadow]: shadow } : s.root,
    {},
    className,
  );

  const handleOnChange = (e: any) => {
    if (onChange) {
      if (withTarget) {
        onChange(e);
      } else {
        onChange(e.target.value);
      }
    }
    return null;
  };

  return (
    <label className={'w-full'}>
      <textarea
        className={rootClassName}
        onChange={handleOnChange}
        autoComplete='off'
        autoCorrect='off'
        autoCapitalize='off'
        spellCheck='false'
        {...rest}
      />
    </label>
  );
};

export default TextArea;
